import useUserList from "../../../shared/functions/useUserList";
import Autocomplete from '@mui/material/Autocomplete';
import {Avatar, TextField} from "@material-ui/core";
import {Col, Row} from "react-bootstrap";
import {useMemo, useState} from "react";

export default function UserSelection({onChange, selectedUser}) {
    const [setUser] = useState(selectedUser)
    const {users, isLoading} = useUserList();

    const handleChange = (user) => {
        onChange && onChange(user)
    }

    const list = useMemo(() => {

        let data = []

        if (setUser) {
            data.push(setUser)
        }

        if (users) {
            users.forEach(user => {
                if (!setUser || user.id !== setUser.Id) {
                    data.push({
                        Id: user?.id,
                        Name: user?.name || user?.displayName || user?.Email,
                        AvatarUrl: user?.photoURL || null,
                        Email: user?.email
                    })
                }
            })
        }


        return data
    }, [setUser, users])

    return (
        <Col className='col-auto pt-3'>
            <Autocomplete
                options={list}
                isOptionEqualToValue={(option, value) => option?.Id === value?.Id}
                getOptionLabel={(user) => user.Name || ''}
                style={{width: 500}}
                loading={isLoading}
                onChange={(event, value) => handleChange(value)}
                defaultValue={setUser ? list[0] : null}
                renderOption={(props, option, state) => (
                    <Row {...props}>
                        <Col className='col-auto'>
                            <Avatar src={option.AvatarUrl}/>
                        </Col>
                        <Col>
                            {option.Name}
                        </Col>
                    </Row>
                )}
                renderInput={(params) => (
                    <TextField {...params} label="Chargé des achats" variant="outlined"/>)
                }
            />

        </Col>
    )
}